import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { StagingClient } from '@/features/logistics/StagingClient';

interface StagingSearch {
  /**
   * The load day, in the URL so the button in a notification opens that day
   * (docs/logistics.md §12.10) — and a refresh keeps it.
   */
  date?: string;
}

const CALENDAR_DAY = /^\d{4}-\d{2}-\d{2}$/;

export const Route = createFileRoute('/_shell/logistics/staging')({
  validateSearch: (search: Record<string, unknown>): StagingSearch => ({
    date:
      typeof search['date'] === 'string' && CALENDAR_DAY.test(search['date'])
        ? search['date']
        : undefined,
  }),
  component: StagingRoute,
});

function StagingRoute() {
  const { date } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <StagingClient
      date={date ?? null}
      onDate={(next) => void navigate({ search: { date: next }, replace: true })}
    />
  );
}
